module.exports = __webpack_public_path__ + "img/cloudinary-stencil.910aee7e.svg";